var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/contentful/components/image-macro.j2"] = require( "macros/contentful/components/image-macro.j2" );
dependencies["macros/contentful/cta-button.j2"] = require( "macros/contentful/cta-button.j2" );
dependencies["macros/contentful/cta-button-helpers.j2"] = require( "macros/contentful/cta-button-helpers.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/editorial-component.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/contentful/editorial-component.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("contentfulUrl")) {
var t_4 = t_1.contentfulUrl;
} else {
cb(new Error("cannot import 'contentfulUrl'")); return;
}
context.setVariable("contentfulUrl", t_4);
env.getTemplate("macros/contentful/components/image-macro.j2", false, "core/templates/contentful/editorial-component.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("buildImage")) {
var t_8 = t_5.buildImage;
} else {
cb(new Error("cannot import 'buildImage'")); return;
}
context.setVariable("buildImage", t_8);
env.getTemplate("macros/contentful/cta-button.j2", false, "core/templates/contentful/editorial-component.j2", false, function(t_10,t_9) {
if(t_10) { cb(t_10); return; }
t_9.getExported(context.getVariables(), frame, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
if(t_9.hasOwnProperty("buildCtaButtons")) {
var t_12 = t_9.buildCtaButtons;
} else {
cb(new Error("cannot import 'buildCtaButtons'")); return;
}
context.setVariable("buildCtaButtons", t_12);
env.getTemplate("macros/contentful/cta-button-helpers.j2", false, "core/templates/contentful/editorial-component.j2", false, function(t_14,t_13) {
if(t_14) { cb(t_14); return; }
t_13.getExported(function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
if(t_13.hasOwnProperty("buildCTAFullWidthClass")) {
var t_16 = t_13.buildCTAFullWidthClass;
} else {
cb(new Error("cannot import 'buildCTAFullWidthClass'")); return;
}
context.setVariable("buildCTAFullWidthClass", t_16);
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")) {
var t_17;
t_17 = (lineno = 6, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.isCenterAligned"]));
frame.set("isCenterAligned", t_17, true);
if(frame.topLevel) {
context.setVariable("isCenterAligned", t_17);
}
if(frame.topLevel) {
context.addExport("isCenterAligned", t_17);
}
output += "\n    ";
var t_18;
t_18 = (runtime.contextOrFrameLookup(context, frame, "isCenterAligned")?"s-editorial--center":"s-editorial--left");
frame.set("alignmentClassName", t_18, true);
if(frame.topLevel) {
context.setVariable("alignmentClassName", t_18);
}
if(frame.topLevel) {
context.addExport("alignmentClassName", t_18);
}
if((lineno = 9, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.backgroundColor"])) && !(lineno = 9, colno = 76, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.backgroundImage"]))) {
var t_19;
t_19 = "style=\"background-color: {{ '#' ~ entry.fields.backgroundColor }}\"";
frame.set("backgroundStyle", t_19, true);
if(frame.topLevel) {
context.setVariable("backgroundStyle", t_19);
}
if(frame.topLevel) {
context.addExport("backgroundStyle", t_19);
}
output += "\n    ";
;
}
else {
output += "\n        ";
var t_20;
t_20 = "";
frame.set("backgroundStyle", t_20, true);
if(frame.topLevel) {
context.setVariable("backgroundStyle", t_20);
}
if(frame.topLevel) {
context.addExport("backgroundStyle", t_20);
}
output += "\n    ";
;
}
output += "\n\n    ";
var t_21;
t_21 = "c-contentful-text--" + (lineno = 15, colno = 69, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"constants.defaultEditorialStyles.pretitle",""]));
frame.set("defaultPretitleClass", t_21, true);
if(frame.topLevel) {
context.setVariable("defaultPretitleClass", t_21);
}
if(frame.topLevel) {
context.addExport("defaultPretitleClass", t_21);
}
output += "\n    ";
var t_22;
t_22 = "c-contentful-text--" + (lineno = 16, colno = 66, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"constants.defaultEditorialStyles.title",""]));
frame.set("defaultTitleClass", t_22, true);
if(frame.topLevel) {
context.setVariable("defaultTitleClass", t_22);
}
if(frame.topLevel) {
context.addExport("defaultTitleClass", t_22);
}
output += "\n    ";
var t_23;
t_23 = "c-contentful-text--" + (lineno = 17, colno = 69, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"constants.defaultEditorialStyles.subtitle",""]));
frame.set("defaultSubtitleClass", t_23, true);
if(frame.topLevel) {
context.setVariable("defaultSubtitleClass", t_23);
}
if(frame.topLevel) {
context.addExport("defaultSubtitleClass", t_23);
}
output += "\n    ";
var t_24;
t_24 = "c-contentful-text--" + (lineno = 18, colno = 65, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"constants.defaultEditorialStyles.body",""]));
frame.set("defaultBodyClass", t_24, true);
if(frame.topLevel) {
context.setVariable("defaultBodyClass", t_24);
}
if(frame.topLevel) {
context.addExport("defaultBodyClass", t_24);
}
output += "\n    ";
var t_25;
t_25 = "c-cta-button--" + (lineno = 19, colno = 62, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"constants.defaultEditorialStyles.button",""]));
frame.set("defaultButtonClass", t_25, true);
if(frame.topLevel) {
context.setVariable("defaultButtonClass", t_25);
}
if(frame.topLevel) {
context.addExport("defaultButtonClass", t_25);
}
output += "\n\n    ";
var t_26;
t_26 = (lineno = 21, colno = 51, runtime.callWrap(t_16, "buildCTAFullWidthClass", context, [(lineno = 21, colno = 66, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.ctaButtonsFullWidth",""]))]));
frame.set("CTAFullWidthClass", t_26, true);
if(frame.topLevel) {
context.setVariable("CTAFullWidthClass", t_26);
}
if(frame.topLevel) {
context.addExport("CTAFullWidthClass", t_26);
}
if((lineno = 23, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.ctaButtonsFullWidth"])) && (lineno = 23, colno = 76, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.ctaLinksLayout"]))) {
var t_27;
t_27 = "c-cta-button__li--" + (lineno = 24, colno = 66, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.ctaLinksLayout",""])) + "-full-width";
frame.set("CTALayoutClass", t_27, true);
if(frame.topLevel) {
context.setVariable("CTALayoutClass", t_27);
}
if(frame.topLevel) {
context.addExport("CTALayoutClass", t_27);
}
output += "\n    ";
;
}
else {
if((lineno = 25, colno = 23, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.ctaLinksLayout"]))) {
output += "\n        ";
var t_28;
t_28 = "c-cta-button__li--" + (lineno = 26, colno = 66, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.ctaLinksLayout",""]));
frame.set("CTALayoutClass", t_28, true);
if(frame.topLevel) {
context.setVariable("CTALayoutClass", t_28);
}
if(frame.topLevel) {
context.addExport("CTALayoutClass", t_28);
}
output += "\n    ";
;
}
else {
output += "\n        ";
var t_29;
t_29 = "";
frame.set("CTALayoutClass", t_29, true);
if(frame.topLevel) {
context.setVariable("CTALayoutClass", t_29);
}
if(frame.topLevel) {
context.addExport("CTALayoutClass", t_29);
}
output += "\n    ";
;
}
;
}
output += "\n\n    ";
var t_30;
t_30 = ((lineno = 32, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.pretitleTextStyle"]))?"c-contentful-text--" + (lineno = 31, colno = 66, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.pretitleTextStyle"])):runtime.contextOrFrameLookup(context, frame, "defaultPretitleClass"));
frame.set("pretitleTextStyle", t_30, true);
if(frame.topLevel) {
context.setVariable("pretitleTextStyle", t_30);
}
if(frame.topLevel) {
context.addExport("pretitleTextStyle", t_30);
}
output += "\n\n    ";
var t_31;
t_31 = ((lineno = 35, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.pretitleTextColor"]))?"color: #" + env.getFilter("replace").call(context, (lineno = 34, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.pretitleTextColor"])),"#","") + ";":"");
frame.set("pretitleTextColor", t_31, true);
if(frame.topLevel) {
context.setVariable("pretitleTextColor", t_31);
}
if(frame.topLevel) {
context.addExport("pretitleTextColor", t_31);
}
output += "\n\n    ";
var t_32;
t_32 = ((lineno = 38, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.titleTextStyle"]))?"c-contentful-text--" + (lineno = 37, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.titleTextStyle"])):runtime.contextOrFrameLookup(context, frame, "defaultTitleClass"));
frame.set("titleTextStyle", t_32, true);
if(frame.topLevel) {
context.setVariable("titleTextStyle", t_32);
}
if(frame.topLevel) {
context.addExport("titleTextStyle", t_32);
}
output += "\n\n    ";
var t_33;
t_33 = ((lineno = 41, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.titleTextColor"]))?"color: #" + env.getFilter("replace").call(context, (lineno = 40, colno = 52, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.titleTextColor"])),"#","") + ";":"");
frame.set("titleTextColor", t_33, true);
if(frame.topLevel) {
context.setVariable("titleTextColor", t_33);
}
if(frame.topLevel) {
context.addExport("titleTextColor", t_33);
}
output += "\n\n    ";
var t_34;
t_34 = ((lineno = 44, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.subtitleTextStyle"]))?"c-contentful-text--" + (lineno = 43, colno = 66, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.subtitleTextStyle"])):runtime.contextOrFrameLookup(context, frame, "defaultSubtitleClass"));
frame.set("subtitleTextStyle", t_34, true);
if(frame.topLevel) {
context.setVariable("subtitleTextStyle", t_34);
}
if(frame.topLevel) {
context.addExport("subtitleTextStyle", t_34);
}
output += "\n\n    ";
var t_35;
t_35 = ((lineno = 47, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.subtitleTextColor"]))?"color: #" + env.getFilter("replace").call(context, (lineno = 46, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.subtitleTextColor"])),"#","") + ";":"");
frame.set("subtitleTextColor", t_35, true);
if(frame.topLevel) {
context.setVariable("subtitleTextColor", t_35);
}
if(frame.topLevel) {
context.addExport("subtitleTextColor", t_35);
}
output += "\n\n    ";
var t_36;
t_36 = ((lineno = 50, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.bodyTextStyle"]))?"c-contentful-text--" + (lineno = 49, colno = 62, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.bodyTextStyle"])):runtime.contextOrFrameLookup(context, frame, "defaultBodyClass"));
frame.set("bodyTextStyle", t_36, true);
if(frame.topLevel) {
context.setVariable("bodyTextStyle", t_36);
}
if(frame.topLevel) {
context.addExport("bodyTextStyle", t_36);
}
output += "\n\n    ";
var t_37;
t_37 = ((lineno = 53, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.bodyTextColor"]))?"color: #" + env.getFilter("replace").call(context, (lineno = 52, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.bodyTextColor"])),"#","") + ";":"");
frame.set("bodyTextColor", t_37, true);
if(frame.topLevel) {
context.setVariable("bodyTextColor", t_37);
}
if(frame.topLevel) {
context.addExport("bodyTextColor", t_37);
}
output += "\n\n    <div class=\"c-editorial ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "alignmentClassName"), env.opts.autoescape);
output += "\" data-qa-editorial-component>\n\n        <div class=\"c-editorial__image\" ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "backgroundStyle"), env.opts.autoescape);
output += " data-qa-editorial-image>\n\n            ";
output += runtime.suppressValue((lineno = 59, colno = 23, runtime.callWrap(t_8, "buildImage", context, [runtime.contextOrFrameLookup(context, frame, "entry"),runtime.makeKeywordArgs({"experience": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")})])), env.opts.autoescape);
output += "\n\n        </div>";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"icon")) {
output += "<div class=\"c-editorial__icon\">\n                ";
output += runtime.suppressValue((lineno = 66, colno = 27, runtime.callWrap(t_8, "buildImage", context, [runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"icon"),runtime.makeKeywordArgs({"experience": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")})])), env.opts.autoescape);
output += "\n            </div>\n        ";
;
}
if((lineno = 70, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.preTitle"]))) {
output += "<h3 class=\"c-editorial__pre-heading ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "pretitleTextStyle"), env.opts.autoescape);
output += "\"\n                style=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "pretitleTextColor"), env.opts.autoescape);
output += "\"\n                data-qa-editorial-pre-title>\n                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"preTitle"), env.opts.autoescape);
output += "\n            </h3>\n        ";
;
}
if((lineno = 79, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.title"]))) {
output += "<h2 class=\"c-editorial__heading ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "titleTextStyle"), env.opts.autoescape);
output += "\"\n                style=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "titleTextColor"), env.opts.autoescape);
output += "\"\n                data-qa-editorial-title>\n                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"title"), env.opts.autoescape);
output += "\n            </h2>\n        ";
;
}
if((lineno = 87, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.subTitle"]))) {
output += "<h3 class=\"c-editorial__subheading ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "subtitleTextStyle"), env.opts.autoescape);
output += "\"\n                style=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "subtitleTextColor"), env.opts.autoescape);
output += "\"\n                data-qa-editorial-sub-title>\n                ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"subTitle"), env.opts.autoescape);
output += "\n            </h3>\n        ";
;
}
if((lineno = 95, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.editorialCopy"]))) {
output += "<div class=\"c-editorial__copy ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "bodyTextStyle"), env.opts.autoescape);
output += "\"\n                style=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "bodyTextColor"), env.opts.autoescape);
output += "\"\n                data-qa-editorial-copy>\n                ";
output += runtime.suppressValue(env.getFilter("markdown").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"editorialCopy")), env.opts.autoescape);
output += "\n            </div>\n\n        ";
;
}
if((lineno = 105, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.ctaLinks"]))) {
output += runtime.suppressValue((lineno = 107, colno = 28, runtime.callWrap(t_12, "buildCtaButtons", context, [runtime.makeKeywordArgs({"baseClass": "editorial","ctaObject": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"ctaLinks"),"defaultButtonClass": runtime.contextOrFrameLookup(context, frame, "defaultButtonClass"),"CTAFullWidthClass": runtime.contextOrFrameLookup(context, frame, "CTAFullWidthClass"),"CTALayoutClass": runtime.contextOrFrameLookup(context, frame, "CTALayoutClass")})])), env.opts.autoescape);
;
}
output += "</div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/editorial-component.j2"] , dependencies)